import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-route SEO block. Renders proper <title>, description, canonical,
 * and Open Graph / Twitter card metadata for search engines and social
 * share crawlers.
 */
export default function SEO({ title, description, path = "/" }) {
  const url = `https://www.sebyx.com${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Sebyx" />
      <meta property="og:image" content="https://www.sebyx.com/og-image.jpg" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://www.sebyx.com/og-image.jpg" />
    </Helmet>
  );
}
